import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from "../common/bus";
import { get, post, put, deletes } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  data: function data() {
    return {
      collapse: false,
      // items: [

      //     {
      //         icon: 'iconfont icon-xuexiaoqingkuang',
      //         index: '9',
      //         title: '公司管理',
      //         subs: [
      //             {
      //                 index: '9-1',
      //                 title: '公司管理',
      //                 path: '/company'
      //             }
      //         ]
      //     },
      //     {
      //         icon: 'iconfont icon-shiziduiwu',
      //         index: '10',
      //         title: '用户管理',
      //         subs: [
      //             {
      //                 index: '10-1',
      //                 title: '用户管理',
      //                 path: '/userManage'
      //             }
      //         ]
      //     },
      //     {
      //         icon: 'iconfont icon-shiziduiwu',
      //         index: '12',
      //         title: '菜单管理',
      //         subs: [
      //             {
      //                 index: '12-1',
      //                 title: '菜单管理',
      //                 path: '/menu'
      //             }
      //         ]
      //     },
      //     {
      //         icon: 'el-icon-edit-outline',
      //         index: '13',
      //         title: '问题反馈',
      //         subs: [
      //             {
      //                 index: '13-1',
      //                 title: '问题反馈',
      //                 path: '/problemFeedback'
      //             }
      //         ]
      //     }

      // ],
      itemss: [{
        icon: 'iconfont icon-xuexiaoqingkuang',
        index: '9',
        title: '公司管理',
        path: '/company'
      }, {
        icon: 'iconfont icon-shiziduiwu',
        index: '10',
        title: '用户管理',
        path: '/userManage'
      }, {
        icon: 'iconfont icon-shiziduiwu',
        index: '12',
        title: '菜单管理',
        path: '/menu'
      }, {
        icon: 'el-icon-edit-outline',
        index: '13',
        title: '问题反馈',
        path: '/problemFeedback'
      }]
    };
  },
  computed: {
    onRoutes: function onRoutes() {
      if (this.$route.path.replace('/', '') == 'task') {
        return '4-3';
      } else if (this.$route.path.replace('/', '') == 'task/village') {
        return '4-1';
      } else if (this.$route.path.replace('/', '') == 'video/analysis') {
        return '7-3';
      } else if (this.$route.path.replace('/', '') == 'funcs') {
        return '2-4';
      } else if (this.$route.path.replace('/', '') == 'control/switchControl') {
        return '3-1-4';
      } else if (this.$route.path.replace('/', '') == 'on-line/monitoring') {
        return '6-1';
      } else if (this.$route.path.replace('/', '') == 'company') {
        return '9-1';
      } else if (this.$route.path.replace('/', '') == 'userManage') {
        return '10-1';
      } else if (this.$route.path.replace('/', '') == 'companyTool') {
        return '11-1';
      } else if (this.$route.path.replace('/', '') == 'menu') {
        return '12-1';
      }
    }
  },
  created: function created() {
    var _this = this;
    window.baseURL = url.baseURL;
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', function (msg) {
      _this.collapse = msg;
    });

    // this.getMonitor3();
  },

  methods: {}
};